import { gql } from "apollo-boost";

import useMutation, { mutationTypes } from "@utils/graphqlUtils";

const MUTATION = gql`
  mutation ($data: WeeklyWateringLogCreateInput!) {
    createOneWeeklyWateringLog(data: $data) {
      id
    }
  }
`;

export default () => useMutation(MUTATION, `Registo Semanal Rega criado`, mutationTypes.CREATE);
